<div class="root-body"
     [ngClass]="{
    'root-body-sidebar-slim': configService.config.menuMode === 'sidebar' || configService.config.menuMode === 'slim',
    'root-body-sidebar-static': configService.config.menuMode === 'sidebar' && configService.config.sidebarStatic,
    'root-body-horizontal': configService.config.menuMode === 'horizontal'}">

    <p-breadcrumb class="breadcrumb mb-3" [model]="breadcrumbs"></p-breadcrumb>

    <p-toast position="top-right"></p-toast>

    <div class="card">
        <p-table [columns]="cols"
                 [value]="payoutTransactions"
                 [lazy]="true"
                 responsiveLayout="auto"
                 selectionMode="single"
                 dataKey="Id"
                 (onLazyLoad)="handleLazyLoad($event)"
                 [selection]="selectedTransaction"
                 (selectionChange)="onSelectionChange($event)"
                 [paginator]="true"
                 [(first)]="first"
                 [rows]="rowsPerPage"
                 [showFirstLastIcon]="false"
                 [totalRecords]="totalRecords"
                 [resizableColumns]="true"
                 [columnResizeMode]="'expand'"
                 [styleClass]="'p-datatable-gridlines'"
                 [scrollable]="true"
                 [autoLayout]="true"
                 [loading]="loading"
                 [scrollHeight]="'flex'">
            <ng-template pTemplate="caption">
                <div class="onboarding-head">
                    <div class="onboarding-head-title">
                        Xendit Transactions (In and Out)
                    </div>
                    <div class="flex flex-row finance-head-right">
                        <div class="ml-4">
                            <button pButton pRipple
                                    class="p-element btn-darkblue p-button p-component"
                                    (click)="onDownloadClick()">Export Data</button>
                        </div>
                        <div class="ml-5 mt-2 mr-2">
                            <column-selector #columnSelector
                                 [defaultColumns]="defaultCols"
                                 (selectedColumnsChange)="onSelectedColumnsChange($event)"
                                 [tableName]="tableName"
                                 [(selectedColumns)]="cols">
                            </column-selector>
                        </div>
                    </div>
                </div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th *ngFor="let col of cols"
                        [pSortableColumn]="col.field"
                        pResizableColumn
                        [style.width]="col.width">
                        {{col.header}}
                        <p-sortIcon class="transactions-column-sorticon" [field]="col.field"></p-sortIcon>
                    </th>
                </tr>
                <tr>
                    <ng-container *ngFor="let filter of cols">
                        <th class="overflow-unset">
                            <ng-container *ngIf="filter.fieldType === fieldTypeEnum.Inputs">
                                <input type="text" pInputText placeholder="{{filter.placeholder}}" [(ngModel)]="txnHeaderSearch[filter.model]"
                                       (input)="handleFilterChange(filter.field, $event)" />
                            </ng-container>
                            <ng-container *ngIf="filter.fieldType === fieldTypeEnum.InputNumber">
                                <p-inputNumber inputId="integeronly" placeholder="{{filter.placeholder}}" [(ngModel)]="txnHeaderSearch[filter.model]"
                                               (ngModelChange)="handleFilterChange(filter.field, $event)"> </p-inputNumber>
                            </ng-container>
                            <ng-container *ngIf="filter.fieldType === fieldTypeEnum.InputDecimalNumber">
                                <p-inputNumber [minFractionDigits]="2" placeholder="{{filter.placeholder}}" [(ngModel)]="txnHeaderSearch[filter.model]"
                                               (ngModelChange)="handleFilterChange(filter.field, $event)"> </p-inputNumber>
                            </ng-container>
                            <ng-container *ngIf="filter.fieldType === fieldTypeEnum.Dropdown">
                                <ng-container *ngIf="filter.take === 'obj'; else dropdown">
                                    <p-dropdown [options]="filter.options" placeholder="{{filter.placeholder}}"
                                                optionLabel="name" [(ngModel)]="txnHeaderSearch[filter.model]"
                                                (ngModelChange)="onChangeHeaderFilterDropDown(filter.field, $event)"></p-dropdown>
                                </ng-container>
                                <ng-template #dropdown>
                                    <p-dropdown [options]="filter.options" placeholder="{{filter.placeholder}}"
                                                optionLabel="name" optionValue="value" [(ngModel)]="txnHeaderSearch[filter.model]"
                                                (ngModelChange)="onChangeHeaderFilterDropDown(filter.field, $event)"></p-dropdown>
                                </ng-template>
                            </ng-container>
                            <ng-container *ngIf="filter.fieldType === fieldTypeEnum.Calendar">
                                <p-calendar [(ngModel)]="txnHeaderSearch[filter.model]"
                                            [showIcon]="true"
                                            placeholder="{{filter.placeholder}}"
                                            dateFormat="dd M yy"
                                            (ngModelChange)="onChangeHeaderFilterDropDown(filter.field, $event)" />
                            </ng-container>
                            <ng-container *ngIf="filter.fieldType === fieldTypeEnum.CalendarTime">
                                <p-calendar [(ngModel)]="txnHeaderSearch[filter.model]"
                                            [timeOnly]="true"
                                            [showIcon]="true"
                                            hourFormat="12"
                                            placeholder="{{filter.placeholder}}"
                                            (ngModelChange)="onChangeHeaderFilterDropDown(filter.field, $event)" />
                            </ng-container>
                        </th>
                    </ng-container>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-transaction let-columns="columns">
                <tr>
                    <td *ngFor="let col of cols" [pSelectableRow]="transaction">
                        <span *ngIf="col.field === 'Id'" class="underline-black-col" (click)="handleShowTransactionInfo(transaction)">
                            {{ transaction[col.field] }}
                        </span>
                        <span *ngIf="col.field === 'DriverName'" class="underline-black-col" (click)="handleShowDriverInfo(transaction)">
                            {{ transaction[col.field] }}
                        </span>
                        <span *ngIf="col.field === 'CustomerName'" class="underline-black-col" (click)="handleShowCustomerInfo(transaction)">
                            {{ transaction[col.field] }}
                        </span>
                        <span *ngIf="col.field !== 'Id' && col.field !== 'DriverName' && col.field !== 'CustomerName'">
                            {{ transaction[col.field] }}
                        </span>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="paginatorleft" let-state>
                <div *ngIf="paginator.Items.length > 0" style="padding-left: 10px">
                    Showing {{first + 1}} to {{first + paginator.Items.length}} of {{totalRecords}} entries
                </div>
            </ng-template>
        </p-table>
    </div>
</div>

<customer-info *ngIf="visibleCustomerDetail"
               [isVisibleCustomerInfo]="visibleCustomerDetail"
               [_customerId]="transactionCustomerId"
               (changedVisibleCustomerInfoEmit)="changedVisibleCustomerDetailEmit($event)">
</customer-info>

<driver-detail [_visibleDetail]="visibleDriverDetail"
               [_driverId]="transactionRiderId"
               (changedVisibleDetailEmit)="changedVisibleDriverDetailEmit($event)"
               *ngIf="visibleDriverDetail">
</driver-detail>

<home-transaction-details *ngIf="visibleTransactionDetail"
                          [showTransactionsSidebar]="visibleTransactionDetail"
                          (updateTransactionsEmit)="updateEventEmit($event)"
                          [_transactionId]="transactionId">
</home-transaction-details>
